export class VenueDetails {
    name: string;
    room: string;
    address: string;
    city: string;
    state: string;
    province: string;
    country: string;
    postalCode: string;
    numberOfClasses: number;
}



// WEBPACK FOOTER //
// ./src/app/organization/components/venues/components/add/venue-add-details.model.ts